import React, {memo, useMemo, useState} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import FieldWrapper from "../FieldWrapper";
import {FormUl} from "../loaderStyled";
import LoginWithMobile from "../LoginWithMobile";
import {OrSection, SignUpButtonArea, TabFormSection} from "../Styled";
import GoogleSignup from "./widgets/GoogleSignup/Loadable";
import GoogleSignupButton from "./widgets/GoogleSignupButton";
// import LoginWithMobileButton from "./widgets/LoginWithMobileButton";
import {TermsAndConditionMessage} from "./widgets/Styled";

interface Props {
    setShowTabs?: React.Dispatch<React.SetStateAction<boolean | true>>;
    setCurrentLoginLayer?: React.Dispatch<React.SetStateAction<string | "emailLoginLayer">>;
    activePage?: string;
}
const SocialSignUp: React.FC<Props> = ({setShowTabs, setCurrentLoginLayer, activePage}: Props) => {
    const [googleAutoLoad, setGoogleAutoLoad] = useState(false);
    const isDocumentClicked = useSelector((state: RootStore) => state.layout.isUserInteracted);
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    const googleJSX = useMemo(() => {
        if (isDocumentClicked) {
            return (
                <>
                    <GoogleSignup googleAutoLoad={googleAutoLoad} />
                    {activePage === "loginPage" && (
                        <LoginWithMobile
                            setShowTabs={setShowTabs}
                            setCurrentLoginLayer={setCurrentLoginLayer}
                        />
                    )}
                    {!isMobile && (
                        <TermsAndConditionMessage>
                            By continuing, you agree to our Terms & Conditions
                        </TermsAndConditionMessage>
                    )}
                </>
            );
        } else {
            return (
                <>
                    <GoogleSignupButton
                        onClick={() => {
                            setGoogleAutoLoad(true);
                        }}
                        onTouchStart={() => {
                            setGoogleAutoLoad(true);
                        }}
                    />
                    {activePage === "loginPage" && (
                        <LoginWithMobile
                            setShowTabs={setShowTabs}
                            setCurrentLoginLayer={setCurrentLoginLayer}
                        />
                    )}
                    <TermsAndConditionMessage>
                        By continuing, you agree to our Terms & Conditions
                    </TermsAndConditionMessage>
                </>
            );
        }
    }, [
        isDocumentClicked,
        googleAutoLoad,
        setCurrentLoginLayer,
        setShowTabs,
        activePage,
        isMobile,
    ]);

    return (
        <TabFormSection>
            <FormUl>
                <FieldWrapper visible={true} fullWidthDiv={true}>
                    <SignUpButtonArea>{googleJSX}</SignUpButtonArea>
                    <OrSection>
                        <span>OR</span>
                    </OrSection>
                </FieldWrapper>
            </FormUl>
        </TabFormSection>
    );
};

export default memo(SocialSignUp);
